<script setup lang="ts">
import type { components as StrapiComponents } from '@core/types/clients/strapi'

const props = defineProps<{
    video: StrapiComponents['schemas']['DynamicFullScreenVideoComponent']
}>()
</script>

<template>
    <section class="fullscreen-video">
        <UIIframe v-if="props.video.videoSrc || props.video.videoId" :video-id="props.video.videoId" :src="props.video.videoSrc" />
        <div class="video-gradient" />
    </section>
</template>

<style scoped lang="scss">
.fullscreen-video {
    position: relative;
    height: 0;
    background-color: rgb(0 0 0 / 20%);
    aspect-ratio: 16 / 9;
    width: 100%;
    height: 100%;
    max-width: 1280px;
    margin: 0 auto;

    .video-gradient {
        position: absolute;
        bottom: -1px; // Hack to avoid gap in some scenarios
        height: 100%;
        width: 100%;
        background: linear-gradient(to bottom, transparent 30%, $body-bg 100%);
        z-index: 4;
        pointer-events: none;

        @media (min-width: 1280px) {
            &:before {
                content: '';
                position: absolute;
                top: -1px;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(to right, transparent 80%, $body-bg 100%);
            }

            &:after {
                content: '';
                position: absolute;
                top: -1px;
                left: 0;
                width: 100%;
                height: 100%;
                background: linear-gradient(to left, transparent 80%, $body-bg 100%);
            }
        }
    }

    // Make sure fullscreen-videos goes to the edge when inside dynamic-content container
    .dynamic-content & {
        @media (max-width: 1279px) {
            margin-left: -15px;
            width: calc(100% + 30px);
        }
    }
}
</style>
